/**
 * Maximum number of codes allowed in a single code set on any profile view that
 * sends codes as a query param (e.g. CPT, HCPCS, ICD10D, Prescriptions, and any
 * other code-bearing view). Requests with a larger code set are blocked
 * client-side before hitting the API.
 */
export const MAX_PROFILE_CODE_SET_SIZE = 100;

/**
 * Filter groups that carry the codes sent as the `code` / `drug` query param.
 * These back every code-bearing profile view, not just a specific few. Only one
 * of these is ever populated for a given view.
 */
export const CODE_FILTER_GROUPS = ['code', 'drug'] as const;
